module.exports = __webpack_public_path__ + "static/media/afialiadoDeSucesso.8c90e66c.png";